/**
 * FeedSuggestedGroups.js — EcoScienceInnova
 * Sidebar widget: suggested groups to join.
 *
 * Props:
 *  - groups: [{ id, name, members, icon? }]
 *  - onJoin: (groupId) => void
 */
import React from 'react';
import { FaUserFriends } from 'react-icons/fa';
import FeedSidebarCard from './FeedSidebarCard';
import './feed.shared.css';

const FeedSuggestedGroups = ({ groups = [], onJoin, title = 'Grupos sugeridos' }) => {
    return (
        <FeedSidebarCard title={title}>
            <div className="feed-widget-scroll">
                {groups.map(g => (
                    <div key={g.id} className="feed-suggested-group">
                        <div className="feed-sg-icon">
                            {g.icon || <FaUserFriends style={{ color: '#FF6600' }} />}
                        </div>
                        <div className="feed-sg-info">
                            <p className="feed-sg-name">{g.name}</p>
                            <p className="feed-sg-members">{g.members} miembros</p>
                        </div>
                        <button className="feed-join-btn" onClick={() => onJoin?.(g.id)}>
                            Unirse
                        </button>
                    </div>
                ))}
            </div>
        </FeedSidebarCard>
    );
};

export default FeedSuggestedGroups;
